import { render, staticRenderFns } from "./arule.vue?vue&type=template&id=64de7f43&"
import script from "./arule.vue?vue&type=script&lang=js&"
export * from "./arule.vue?vue&type=script&lang=js&"
import style0 from "./arule.vue?vue&type=style&index=0&id=64de7f43&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports